import styled from "styled-components";
import BackgroundImage from "components/styles/BackgroundImage";

export const MediaBg = styled(BackgroundImage)`
  /* transition: all .5s;
  box-shadow: inset 0px 0px 0px 3px rgb(40, 193, 246, 0);
  :hover {
    transform: translate(0,-1.5%);
    box-shadow: inset 0px 0px 0px 3px #28c1f6;
  } */
`;
